import React from 'react';
import useIsMobile from "@Hooks/selector/useIsMobile";
import TicketType from "@Generic/ticket/TicketType";
import TicketTypeNotification from "@Generic/ticket/TicketTypeNotification";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";

interface RouteTicketTypeSectionProps {
    hasMTicket: boolean,
    routeType: RouteTransferTypeKeys,
}

function RouteTicketTypeSection({hasMTicket, routeType}: RouteTicketTypeSectionProps) {
    const isMobile = useIsMobile()

    if (!isMobile) {
        return (
            <TicketTypeNotification
                hasMTicket={hasMTicket}
                routeType={routeType}
            />
        )
    }

    return (
        <TicketType
            hasMTicket={hasMTicket}
            routeType={routeType}
        />
    )
}

export default RouteTicketTypeSection